import React from "react";
import { Navigate } from "react-router-dom";
import PathConstants from "./pathConstants";
import ClaimableAuthenticator from "../components/Shared/ClaimableAuthenticator";

const MedicationConditionEligibilityPage = React.lazy(
  () => import("../pages/Product/Eligibility/MedicationConditionEligibility"),
);
const DenialReasonEligibilityPage = React.lazy(
  () => import("../pages/Product/Eligibility/DenialReasonEligibility"),
);
const PatientInfo = React.lazy(
  () => import("../pages/Product/Eligibility/PatientInfo"),
);
const NiceToMeetYou = React.lazy(
  () => import("../pages/Product/Eligibility/NiceToMeetYou"),
);
const EligibilitySuccessPage = React.lazy(
  () => import("../pages/Product/Eligibility/EligibilitySuccess"),
);
const LetsGetStarted = React.lazy(
  () => import("../pages/Product/SetupFlow/LetsGetStarted"),
);

const routes = [
  {
    path: PathConstants.Root,
    element: <Navigate to={PathConstants.MedicationConditionEligibility} />,
  },
  {
    path: PathConstants.MedicationConditionEligibility,
    element: <MedicationConditionEligibilityPage />,
  },
  {
    path: PathConstants.DenialReasonEligibility,
    element: <DenialReasonEligibilityPage />,
  },
  {
    path: PathConstants.PatientInfo,
    element: <PatientInfo />,
  },
  {
    path: PathConstants.NiceToMeetYou,
    element: <NiceToMeetYou />,
  },
  {
    path: PathConstants.EligibilitySuccess,
    element: <EligibilitySuccessPage />,
  },
  {
    path: PathConstants.LetsGetStarted,
    element: (
      <ClaimableAuthenticator>
        <LetsGetStarted />
      </ClaimableAuthenticator>
    ),
    className: "body_background_light-volt-fade-down",
  },
];

export default routes;
